$.fn.Filters = function()
{
  var self = this;
  self.current_filter = 'all';
  self.is_updating = false;

  self.filter_clicked = function()
  {
    // no click if list is animating
    if (self.is_updating){
      return false;
    }

    // remove current filter
    if ($(this).hasClass('current')){
      $(this).removeClass('current');
      if ($(this).data('filter') == "long" || $(this).data('filter') == "court"){
        self.current_filter = 'film';
      } else {
        self.current_filter = 'all';
      }

    // or add new filter
    } else {
      $('.filter').removeClass('current');
      if ($(this).data('action') != undefined){
        if ($(this).data('action') == 'expand'){
          $(this).parent().hide();
          self.find('.width').removeClass('d-none');
        } else if ($(this).data('action') == 'close'){
          self.find('a[data-action=expand]').parent().show();
          self.find('.width').addClass('d-none');
          self.current_filter = 'all';
        }
      }
      if ($(this).hasClass('filter')){
        $(this).addClass('current');
        self.current_filter = $(this).data('filter');
      }
    }
    self.update_list();
    return false;
  };

  self.update_list = function()
  {
    self.is_updating = true;
    $('.projects__list').addClass('projects__list--state-hidden');
    setTimeout(function(){
      $('.projects__list .project').each(function(){
        if (self.current_filter == 'all' || $(this).data('filters').indexOf(self.current_filter) !== -1){
          $(this).show();
        } else {
          $(this).hide();
        }
        $('.projects__list').removeClass('projects__list--state-hidden');
        self.is_updating = false;
      });
    }, 175);
  };

  return function()
  {
    if (!self.hasClass('active')){
      self.addClass('active');
      self.find('a').on('click', self.filter_clicked);
    }
    return self;
  }();
};
